import { getAppInfo, getIsWhiteLabel } from '~/helpers'
import i18n from '~/i18n'
import { primary as theme } from '~/styles/themes'

import { formatCompareMetricLabel, formatStylesChart } from '../../helpers'
import { CreateDataset } from '../types'
import { OptionsScale } from './types'

const appInfo = getAppInfo()
const isWhiteLabel = getIsWhiteLabel()

const axisID = 'y-conversions'

const settings = {
  label: i18n.t('rm:metrics.conversions'),
  color:
    isWhiteLabel && appInfo?.colors?.primary
      ? appInfo.colors.primary
      : theme.colors.success,
  dataKey: 'conversionNumber' as keyof ReportHistoryCampaigns,
  order: 110
}

const dataset: CreateDataset = ({ data, isCompare = false }) => ({
  yAxisID: isCompare ? `${axisID}-compare` : axisID,
  type: 'bar',
  label: formatCompareMetricLabel({ label: settings.label, isCompare }),
  data: data?.[settings.dataKey] || null,
  order: isCompare ? settings.order - 1 : settings.order,

  ...formatStylesChart({
    color: settings.color,
    bgStyle: 'alphaGradient',
    isCompare
  })
})

const optionsScale: OptionsScale = ({
  showScaleRuler = true,
  drawOnChartArea = true,
  position = 'left',
  isCompare = false
}) => ({
  [isCompare ? `${axisID}-compare` : axisID]: {
    display: showScaleRuler,
    grid: {
      // If true, draw lines on the chart area inside the axis lines. This is useful
      // when there are multiple axes and you need to control which grid lines are drawn.
      drawOnChartArea
    },
    position,
    suggestedMin: 0,
    beginAtZero: true,
    ticks: {
      z: 10,
      color: theme.colors.successDark
    }
  }
})

const conversionsPreset = { axisID, dataset, optionsScale, settings }

export default conversionsPreset
